import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useInView } from "../../util/useInView";
import type { Core } from "./ProdutosContent";

const pad = (n: number) => String(n).padStart(2, "0");

// Calriz Core no painel em destaque (como o case em destaque): o fluxo do Marketplace até a ativação (a etapa do
// Core em destaque) e os quatro recursos, que entram em cascata. band = fundo em faixa clara.
export default function ProductCore({ core, band }: { core: Core; band?: boolean }) {
  const { t } = useTranslation();
  const { id, Icon, name, accent, text, flowLabel, flow, features, tip } = core;
  const [ref, state] = useInView<HTMLElement>(0.15);
  // a etapa do próprio Core vem destacada; os textos do fluxo trazem o nome dele
  const coreStep = flow.indexOf(name);

  return (
    <section
      className={`cz-prod-section${band ? " cz-prod-section--band" : ""}`}
      id={id}
      aria-labelledby={`${id}-title`}
    >
      <div className="cz-prod-section__inner">
        <article ref={ref} className={`cz-prod-panel cz-prod-panel--featured${state}`}>
          <header className="cz-prod-panel__lead">
            <span className="cz-prod-panel__badge" aria-hidden="true">
              <Icon size={30} strokeWidth={1.6} />
            </span>
            <div className="cz-prod-panel__heading">
              <span className="cz-eyebrow">{t("produtos_page.labels.eyebrow")}</span>
              <h2 className="cz-prod-title" id={`${id}-title`}>
                {name} <span className="cz-prod-accent">{accent}</span>
              </h2>
              <p className="cz-prod-subtitle">{text}</p>
            </div>
          </header>

          <ol className="cz-prod-flow" aria-label={flowLabel}>
            {flow.map((step, i) => (
              <li
                key={step}
                className={`cz-prod-flow__step${i === coreStep ? " is-core" : ""}`}
                data-reveal
                style={{ "--i": i } as React.CSSProperties}
              >
                {step}
              </li>
            ))}
          </ol>

          <ul className="cz-prod-tiles">
            {features.map(({ Icon: FeatureIcon, title, text: description }, i) => (
              <li
                key={title}
                className="cz-prod-tile"
                data-reveal
                style={{ "--i": flow.length + i } as React.CSSProperties}
              >
                <div className="cz-prod-tile__top">
                  <span className="cz-prod-tile__icon" aria-hidden="true">
                    <FeatureIcon size={20} strokeWidth={1.8} />
                  </span>
                  <span className="cz-prod-num">{pad(i + 1)}</span>
                </div>
                <strong className="cz-prod-tile__title">{title}</strong>
                <span className="cz-prod-tile__text">{description}</span>
              </li>
            ))}
          </ul>

          <footer className="cz-prod-panel__foot">
            <p className="cz-prod-tip">
              <Lightbulb size={18} strokeWidth={1.8} aria-hidden="true" />
              <span>{tip}</span>
            </p>
          </footer>
        </article>
      </div>
    </section>
  );
}
